export default [    
    {
        path: '/adm/usuarios',
        name: 'admUsers',
        component: () => import('./Home')
    },  
    {
        path: '/adm/usuarios/:id',
        name: 'admUsersForm',
        component: () => import('./Form')
    },    
   
]